import React from 'react';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {createRoot} from "react-dom/client";
import MainContent from "./App";
import {createBrowserRouter, RouterProvider} from "react-router";


const container = document.getElementById("root");
const router = createBrowserRouter([
    {
        path: "/",
        element: <MainContent />,
    },
]);
const root = createRoot(container);


root.render(
    <RouterProvider router={router} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
